export const formType = {
    "CREATE": 'CREATE',
    "EDIT": 'EDIT'
};
